import React, { useContext, useState } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import environment from "constants/apiConst";
import { __ShowTradeAgreement } from "request/configuration/__TradeAgreement";
import { ConfigIconStatus } from "./components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;

const TbodyTradeAgreement = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const [loadingIcons, setLoadingIcons] = useState(false);
  const { setUpdate, update, setLoading } = useContext(ConfigurationCRUDContext);
  const [openAlert] = AlertErrorAlert();

  const desactivarAndActivar = async (result) => {
    setLoadingIcons(true);
    // setLoading(true);

    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(
            token,
            environment.TRADE_AGREEMENT_DESACTIVE,
            data.id
          )
          : await __ACTIVAR(token, environment.TRADE_AGREEMENT_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        openAlert(resultado.data.status.message, "success");
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
      setLoadingIcons(false);
    }
  };

  const handleState = async () => {
    try {
      const res = await __ShowTradeAgreement(token, data.id);
      const result = res.data.status.data.status_tradeAgreement;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data?.code_tradeAgreement}</Td>
      <Td className="text-center">{data?.name_tradeAgreement}</Td>
      <Td className="text-center">{data?.observation}</Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data?.status_tradeAgreement === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data?.status_tradeAgreement}
        >
          {/*       <IconGeneric
            color={data.status_tradeAgreement === 1 ? "#03C39A" : "#bababa"}
            as={BsCheckCircleFill}
          /> */}
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_tradeAgreement}
          />
        </TdState>
      </Tooltip>

      <Td className="text-center">
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyTradeAgreement;
